module.exports = __webpack_public_path__ + "img/red-packet-bubble-none.8b08f971.png";